export enum SupportedLanguages {
  English = 'en',
  French = 'fr',
}
